export default {"src":"/_next/static/media/icon-detached.3dbbce2a.svg","height":28,"width":30,"blurWidth":0,"blurHeight":0};